import { render } from "./mainSlot.vue?vue&type=template&id=c0c7fec2"
import script from "./mainSlot.vue?vue&type=script&lang=js"
export * from "./mainSlot.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__